import { render, staticRenderFns } from "./prouducts.vue?vue&type=template&id=7985c00c&scoped=true&"
import script from "./prouducts.vue?vue&type=script&lang=js&"
export * from "./prouducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7985c00c",
  null
  
)

export default component.exports